document.addEventListener("DOMContentLoaded", function () {

  /************************************************************************
    PILLS SLIDER  
    */
  // Find all slider sections on the page
  const sliderSections = document.querySelectorAll(
    '[class*="edge-slider-section-"]'
  );

  // Initialize each slider independently
  sliderSections.forEach(function (section) {
    const sectionId = section
      .getAttribute("class")
      .match(/edge-slider-section-(.*)/)[1];

    // Find the swiper element within this specific section
    const swiperElement = section.querySelector(".edge-swiper");

    if (!swiperElement) {
      console.error(`Swiper container not found in section ${sectionId}`);
      return;
    }

    try {
      // Initialize Swiper for this specific section
      const edgeSwiper = new Swiper(swiperElement, {
        slidesPerView: "auto",
        centeredSlides: false,
        spaceBetween: 20,
        loop: false,
        navigation: {
          nextEl: section.querySelector(".edge-slider-nav--next"),
          prevEl: section.querySelector(".edge-slider-nav--prev"),
        },
        breakpoints: {
          768: {
            slidesPerView: 1.1,
            spaceBetween: 30,
          },
        },
        on: {
          init: function () {
            updateActiveTabs(this, section);
          },
          slideChange: function () {
            updateActiveTabs(this, section);
          },
        },
      });

      // Store the swiper instance on the section element for reference
      section.edgeSwiper = edgeSwiper;

      // Tab Click Event - scoped to this section
      const tabs = section.querySelectorAll(".edge-slider-tab");
      tabs.forEach((tab) => {
        tab.addEventListener("click", function () {
          const index = parseInt(this.getAttribute("data-index"));

          // Use the swiper instance stored on this specific section
          if (
            section.edgeSwiper &&
            typeof section.edgeSwiper.slideTo === "function"
          ) {
            section.edgeSwiper.slideTo(index);
          } else {
            console.error(
              `Swiper not properly initialized for section ${sectionId}`
            );
          }
        });
      });
    } catch (error) {
      console.error(
        `Error initializing Swiper for section ${sectionId}:`,
        error
      );
    }
  });

  // Re-initialize when Shopify sections are loaded/reloaded
  document.addEventListener("shopify:section:load", function (event) {
    const section = event.target;

    // Check if this is one of our slider sections
    if (
      section.classList.contains(
        "edge-slider-section-" + event.detail.sectionId
      )
    ) {
      // Find the swiper element within this specific section
      const swiperElement = section.querySelector(".edge-swiper");

      if (swiperElement) {
        // Re-initialize the swiper (using the same code as above)
        // Copy the initialization code here...
      }
    }
  });

  // Select the element to move
  const badgeElement = document.querySelector('[data-block-handle="preview_badge"]');

  // Select the target container
  const titleWrapper = document.querySelector('#mit-product-title-wrapper');

  // Move it, if both elements exist
  if (badgeElement && titleWrapper) {
    titleWrapper.appendChild(badgeElement);
    badgeElement.style.opacity = '1';
  }


  const productForm = document.querySelector('#product-form-installment');
  const productForm2 = document.querySelector('product-form');
  const priceContainer = document.querySelector('[data-update-block="price-extended-main"]');

  if(priceContainer && productForm) {
    // Move the price container to the product form
    priceContainer.querySelector(".sidebar-widget__content").appendChild(productForm);
    priceContainer.querySelector(".sidebar-widget__content").appendChild(productForm2);

    productForm.style.opacity = '1';
    productForm2.style.opacity = '1';

  }

  // Method 2: Stop animation on click with tooltip
  if(document.getElementById('mit-scroll-to-discover')) {
    document.getElementById('mit-scroll-to-discover').addEventListener('click', function() {
      this.classList.add('no-animation');
    });
  }
  

  // Optional: Add some feedback when animation is paused
  if(document.getElementById('mit-scroll-to-discover')) {
    document.getElementById('mit-scroll-to-discover').addEventListener('click', function() {
      if (!this.classList.contains('no-animation')) {
        this.classList.add('no-animation');
        
        // Optional: Brief visual feedback that animation was paused
        this.style.opacity = '0.7';
        setTimeout(() => {
          this.style.opacity = '1';
        }, 200);
      }
    });
  }
  

  /* Header */
  /*
  if(document.getElementById('site-header')) {
    const header = document.getElementById('site-header');

    // Add throttled scroll event listener
    window.addEventListener('scroll', throttle(handleScroll, 16)); // ~60fps

    // Also listen for resize events as they can affect scroll position
    window.addEventListener('resize', throttle(handleScroll, 16));

    // Initial check in case page is already scrolled
    handleScroll();
  }
  */


  /* Single product */
  /*
  if(document.querySelector('.template-product')) {
    document.querySelector("#logo img").src = "https://cdn.shopify.com/s/files/1/0934/9270/7677/files/frequencell-black.png?v=1750684673";
    document.querySelector("#logo img").style.opacity = '1';
  }
    */

  /************************************************************************ 
    FUNCTIONS
    */
  
  // Tabs functionality - scoped to this section
  function updateActiveTabs(swiper, sectionElement) {
    const tabs = sectionElement.querySelectorAll(".edge-slider-tab");
    tabs.forEach((tab, index) => {
      if (index === swiper.activeIndex) {
        tab.classList.add("active");
      } else {
        tab.classList.remove("active");
      }
    });
  }

  // Throttle function for better performance
  function throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }

  // Improved scroll handler function
  /*
  function handleScroll() {

    const header = document.getElementById('site-header');
    // Use multiple methods to get scroll position for better browser compatibility
    const scrollTop = Math.max(
      window.pageYOffset || 0,
      document.documentElement.scrollTop || 0,
      document.body.scrollTop || 0
    );
    
    // Add a small threshold to prevent flickering near the top
    const threshold = 5;
    
    if (scrollTop > threshold) {
      if (!header.classList.contains('scrolled')) {
        header.classList.add('scrolled');

        /*if(document.querySelector(".template-product")) {
          document.querySelector("#logo img").src = "https://cdn.shopify.com/s/files/1/0934/9270/7677/files/logo-white.svg?v=1750606074";
          document.querySelector("#logo img").style.opacity = '1';
      
          }*/
      /*
        }
      */
      /*
    } else {
      if(header) {
        if (header.classList.contains('scrolled')) {
          header.classList.remove('scrolled');

          /*document.querySelector("#logo img").src = "https://cdn.shopify.com/s/files/1/0934/9270/7677/files/frequencell-black.png?v=1750684673";
          document.querySelector("#logo img").style.opacity = '1';*/
          /*
        }
      }
      
    }
  }
  */

});
